import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Crown } from "lucide-react";
import { api, fmt } from "@/lib/api";
import { ShinyButton } from "@/components/ui/ShinyButton";

/** Slim PRIME promo band on the homepage — links to the full /prime page. */
export default function PrimeStrip() {
  const navigate = useNavigate();
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    api.get("/prime/config").then(({ data }) => setCfg(data)).catch(() => {});
  }, []);

  return (
    <section className="mx-auto max-w-7xl px-6 lg:px-12" data-testid="prime-strip">
      <motion.div
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center justify-between gap-5 relative overflow-hidden rounded-3xl border border-[#E4B66D]/30 bg-[#242521] px-7 py-7 shadow-[0_20px_50px_-16px_rgba(36,37,33,0.45)] sm:flex-row sm:px-10"
      >
        <div className="flex items-center gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#E4B66D]/15">
            <Crown className="h-6 w-6 text-[#E4B66D]" />
          </span>
          <div>
            <p className="font-display text-xl font-semibold tracking-tight text-[#F8F6F0]">
              PAQVERO <span className="text-[#E4B66D]">PRIME</span>
            </p>
            <p className="mt-0.5 text-xs text-[#C9C7BC] sm:text-sm">
              {cfg
                ? `${fmt(cfg.delivery_discount)} off every eligible delivery · member-only prices · ${cfg.validity_days} days for ${fmt(cfg.price)}`
                : "Delivery savings · member-only prices"}
            </p>
          </div>
        </div>
        <ShinyButton
          data-testid="prime-strip-cta"
          onClick={() => navigate("/prime")}
          variant="prime"
          contentClassName="whitespace-nowrap px-6 py-3 text-sm font-bold"
        >
          Explore PRIME
        </ShinyButton>
      </motion.div>
    </section>
  );
}
